<div class="otp-container">
  <ngx-app-bar
    class="w-100"
    [title]="state.updateSejam ? 'به روز رسانی اطلاعات سجام' : 'بررسی حساب سجام'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="otp-content">
    <div class="otp-description">
      <span>کد ارسال شده به شماره موبایل حساب سجام را وارد کنید.</span>
    </div>
    <app-pin-input
      [type]="'OTP'"
      (pinChange)="onChanged($event)"
      [hasError]="hasError"
      [value]="otp"
    ></app-pin-input>
    <div class="otp-buttons">
      <ngx-button
        buttonId="RESEND_OTP"
        [style]="'tinted-on-elevated'"
        size="medium"
        [disabled]="inProgress"
        (clickHandler)="resend()"
      >
        @if (inProgress) {
          <ngx-count-down
            [timeInSeconds]="120"
            [type]="'mm:ss'"
            (finished)="onTimerStopped()"
          ></ngx-count-down>
        } @else {
          <span>ارسال دوباره کد</span>
        }
      </ngx-button>

      <ngx-button
        buttonId="OTP_CONFIRM"
        [style]="'fill'"
        [brandButton]="true"
        size="medium"
        [isLoading]="isLoading"
        [disabled]="otp.length < 5 || !inProgress"
        (clickHandler)="registerCustomer()"
      >
        ادامه
      </ngx-button>
    </div>
  </div>
</div>
